import {
    Container,
    FormControlLabel,
    FormGroup,
    IconButton, InputAdornment,
    Radio,
    RadioGroup,
    TextField
} from "@mui/material";
import {Box} from "@mui/system";
import {useState} from "react";
import {ProfileCampaign} from "./ProfileCampaign";
import {DEFAULT_ENV, getEnvName} from "../Utils/CommonUtils";
import {useLocation, useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";

import CachedIcon from '@mui/icons-material/Cached';

export const ProfileSearch = () => {

    const [searchParams, setSearchParams] = useSearchParams();
    const isIframe = useLocation().pathname === '/profile_iframe';

    const userId = searchParams.get('userId') || '';


    const sourceMode = useSelector((state) => state.data.SourceMode);
    const env = sourceMode.isProd?"production":getEnvName('env', sourceMode, searchParams) || DEFAULT_ENV

    const [searchType, setSearchType] = useState('campaign');


    const [refreshKey, setRefreshKey] = useState(0);
    const handleRefresh = () => setRefreshKey(k => k + 1);


    const handleUserIdChange = (event) => {
        updateSearchParams('userId', event.target.value)
    }

    const handleSearchTypeChange = (event) => {
        setSearchType(event.target.value);
    };


    const updateSearchParams = (param, value) => {
        const params = new URLSearchParams(searchParams);
        if (value) params.set(param, value);
        else params.delete(param);
        setSearchParams(params, {replace: true});
    }

    return <Container maxWidth={"100%"} sx={{px: 0, pt: 1, pb: 1, mt: isIframe ? 0 : '48px', height: isIframe ? '100dvh' : 'calc(100dvh - 64px)', display: 'flex', flexDirection: 'column'}}>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center', mb: 1, flexShrink: 0 }}>
            <FormGroup sx={{ flex: 1, minWidth: 220 }}>
                <TextField
                    size="small"
                    value={userId}
                    onChange={handleUserIdChange}
                    label="User ID"
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="refresh"
                                    onClick={handleRefresh}
                                    edge="end"
                                    size="small"
                                >
                                    <CachedIcon />
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />

            </FormGroup>

            <FormGroup>
                <RadioGroup
                    aria-label="Profile type"
                    row
                    value={searchType}
                    onChange={handleSearchTypeChange}
                >
                    <FormControlLabel
                        value="campaign"
                        control={<Radio />}
                        label="Campaign"
                    />
                    <FormControlLabel
                        value="abtest"
                        control={<Radio />}
                        label="AB Test"
                    />
                </RadioGroup>
            </FormGroup>
        </Box>

        <Box sx={{flex: 1, minHeight: 0}}>
            <ProfileCampaign key={`${env}:${userId}:${searchType}`} refreshKey={refreshKey} env={env} userId={userId} type={searchType} />
        </Box>

    </Container>
}

